export default {
    setAnimations(state, animations) {
        state.animations = animations;
    },
    setSaving(state, saving) {
        state.saving=saving;
    },
  
};